import angular from 'angular'

import sale from './sale/sale.module'
import axletree from './axletree/axletree.module'
import piece from './piece/piece.module'
import sterile from './sterile/sterile.module'

const name = 'scrapping'

angular.module(name, [
  sale,
  axletree,
  piece,
  sterile,
])

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/scrapping.module.js